import Swiper from "swiper";
import { classExists } from "../helper/class-exists";

const wizardSlider = () => {

};

const wizardSteps = () => {
  const sliders = document.querySelectorAll(".js-radio-slider");

  classExists(sliders);

  sliders.forEach(function (swiperClass) {
    let slidesVisible =  swiperClass.dataset.slidesVisible;
    let slidesVisibleMobile =  swiperClass.dataset.slidesVisibleMobile;

    if(!slidesVisible) {
      slidesVisible = 4;
      slidesVisibleMobile = "auto";
    }

    const swiper = new Swiper(swiperClass, {
      slidesPerView: slidesVisibleMobile,
      slideToClickedSlide: true,
      spaceBetween: 8,
      clamp: true,
      breakpoints: {
        768: {
          spaceBetween: 24,
          // slidesPerView: slidesVisible,
        },
      },
    });
  });
};

const wizardStepsRange = () => {
  const inputRanges = document.querySelectorAll(".js-range-slider");

  classExists(inputRanges);

  inputRanges.forEach((elem) => {
    const inputRange = elem.querySelector(".range-slider");
    const priceValue = elem.querySelector(".price-value");

    const percentRange = inputRange.value * (100 / inputRange.max);
    inputRange.style.setProperty("--range-value", percentRange);
    priceValue.textContent = inputRange.value;

    inputRange.addEventListener("input", () => {
      const percentRange = inputRange.value * (100 / inputRange.max);
      inputRange.style.setProperty("--range-value", percentRange);
      priceValue.textContent = inputRange.value;
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  wizardSteps();
  wizardStepsRange();
});

window.addEventListener('load', () => {
  let wizardFormTemplate = document.querySelector('.forex-wizard-template');
  let wizardForm = document.querySelector('.wizard-form');
  if (wizardForm) {
    let wizardFormSwiper = new Swiper('.wizard-form', {
      slidesPerView: 1,
      autoplay: false,
      allowTouchMove: false,
    });

    let nextStepButton = document.querySelector('.next-step');
    if (nextStepButton) {
      nextStepButton.addEventListener('click', () => {
        let experienceSelection = document.querySelectorAll('input[name="experience"]:checked');
        if (!experienceSelection.length) {
          let experienceValidationText = document.querySelector('.experience-radioset').dataset.validationText;
          alert(experienceValidationText);
          return false;
        }
        let frequencySelection = document.querySelectorAll('input[name="frequency"]:checked');
        if (!frequencySelection.length) {
          let frequencyValidationText = document.querySelector('.frequency-radioset').dataset.validationText;
          alert(frequencyValidationText);
          return false;
        }
        let paymentSelection = document.querySelectorAll('input[name="payment"]:checked');
        if (!paymentSelection.length) {
          let paymentValidationText = document.querySelector('.payment-radioset').dataset.validationText;
          alert(paymentValidationText);
          return false;
        }
        let nextStepValue = nextStepButton.dataset.stepValue;
        wizardFormSwiper.slideTo(nextStepValue);

        let rawWizardForm = wizardForm.querySelector('form');
        let wizardFormValues = new FormData(rawWizardForm);

        let wizardFormParams = wizardFormValues.entries();
        let data = Object.fromEntries(wizardFormParams);
        data['sub_action'] = 1;
        lsApi.getBrokersByWizard(data, (jqxhr, status) => {
          if (status !== 'success') {
            console.log('Error fetching Forex Wizard Brokers');
            return;
          }

          /*let response = JSON.parse(jqxhr.responseText);*/
          localStorage.setItem('user_data', btoa(jqxhr.responseText));
        });
      });
    }

    let submitWizardButton = document.querySelector('.finalize-selection');
    if (submitWizardButton) {
      submitWizardButton.addEventListener('click', () => {
        let agreementCheckbox = document.getElementById('agreement-checkbox');
        if (!agreementCheckbox) {
          alert(wizardFormTemplate.dataset.agreementText);
          return false;
        }

        let rawWizardForm = wizardForm.querySelector('form');
        if (!rawWizardForm.reportValidity()) {
          let tmpSubmit = document.createElement('button');
          rawWizardForm.appendChild(tmpSubmit);
          tmpSubmit.click();
          rawWizardForm.removeChild(tmpSubmit);
          return false;
        }

        let wizardFormValues = new FormData(rawWizardForm);

        let wizardFormParams = wizardFormValues.entries();
        let data = Object.fromEntries(wizardFormParams);
        let userData = localStorage.getItem('user_data');
        if (userData) {
          userData = JSON.parse(atob(userData));
          let finalData = {
            sub_action: 2,
          };
          finalData = {...data, ...finalData, brokers: userData};
          if (document.querySelector('#overlay')) {
            document.querySelector('#overlay').style.display = 'block';
          }
          lsApi.getBrokersByWizard(finalData, (jqxhr, status) => {
            if (status !== 'success') {
              console.log('Error fetching Forex Wizard Brokers');
              return;
            }

            let response = JSON.parse(jqxhr.responseText);
            if (response.forex_wizard_results_url) {
              window.parent.location.href = response.forex_wizard_results_url;
            }
          });
        }
      });
    }
  }
});